const Loading = (props) => {
    return <div className="loading"><span className="material-icons">autorenew</span></div>
}
export default Loading